import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
var PayoutComponent = /** @class */ (function () {
    function PayoutComponent(dashboardService, router, errorHandlerService) {
        this.dashboardService = dashboardService;
        this.router = router;
        this.errorHandlerService = errorHandlerService;
        this.records = [];
        this.status = "";
        this.msg = "";
        this.manualPayShow = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.subscriptions = [];
    }
    PayoutComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    PayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        var s1 = this.dashboardService.payoutList().subscribe(function (data) {
            console.log("payout list =" + data);
            _this.records = data;
        }, function (error) {
            console.log("The error inside the Error Handler==>" + error);
        });
        this.subscriptions.push(s1);
    };
    PayoutComponent.prototype.makePaypalPayment = function (id) {
        this.manualPayoutId = id;
        this.manualPayShow = true;
    };
    PayoutComponent.prototype.manualPayClose = function () {
        this.payPalTxnId = null;
        this.manualPayoutId = null;
        this.manualPayShow = false;
    };
    PayoutComponent.prototype.savePaypalId = function () {
        var _this = this;
        this.showSpinner = true;
        if (this.manualPayoutId != undefined && this.manualPayoutId != null && this.payPalTxnId != undefined && this.payPalTxnId != null) {
            var s3 = this.dashboardService.makeManualPayout(this.manualPayoutId, this.payPalTxnId).subscribe(function (data) {
                _this.showSpinner = false;
                _this.msg = data.error;
                _this.records = data.payouts;
                _this.status = data.status;
                if (_this.status != null && _this.status != '') {
                    _this.createInfoAlert(_this.status);
                }
                else {
                    _this.createInfoAlert(_this.msg);
                }
                _this.manualPayClose();
            }, function (error) {
                _this.manualPayClose();
                _this.showSpinner = false;
                _this.handleError(error);
            });
            this.subscriptions.push(s3);
        }
        else {
            this.manualPayClose();
            this.createInfoAlert("Paypal TXN ID is required.");
            this.showSpinner = false;
        }
    };
    PayoutComponent.prototype.makePayment = function (id) {
        var _this = this;
        if (confirm("Do you really want to make payment now *****it will make Paypal transfer****?")) {
            var s2 = this.dashboardService.makePayout(id).subscribe(function (data) {
                //console.log("in service response......."+JSON.stringify(data));
                _this.msg = data.error;
                _this.records = data.payouts;
                _this.status = data.status;
                //console.log(" msg ="+this.msg.response.message+" and status="+this.status);
                //TODO: Kandarp please show error message if this.msg has any value
                //if this.status has something show that message as well
                if (_this.status != null && _this.status != '') {
                    _this.createInfoAlert(_this.status);
                }
                else {
                    _this.createInfoAlert(_this.msg);
                }
            }, function (error) {
                _this.handleError(error);
            });
            this.subscriptions.push(s2);
        }
    };
    PayoutComponent.prototype.handleError = function (error) {
        var url = error.url;
        if (url == undefined) {
            return;
        }
        this.errorHandlerService.throwError(error);
    };
    PayoutComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    PayoutComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return PayoutComponent;
}());
export { PayoutComponent };
//# sourceMappingURL=payout.component.js.map